import React, { useState } from "react";
import { LOGO_HOTAREA } from "../../constants/urls";
import Login from "../Login/Login";
import * as S from "./Styled";
import LockIcon from "@mui/icons-material/Lock";
import { CircularProgress } from "@mui/material";

const OnlineOffer = ({
    type,
    isAuthenticated,
    coupon,
    categorie,
    openModal,
    buttonColor,
    getcouponRedirect,
    utmSource,
    utmCampaign,
    userId,
    showAlert,
    incentiveId,
    slug
}) => {
    const [loadingRedirect, setLoadingRedirect] = useState(false);
    const isBlocked = !isAuthenticated && categorie.type === "LOYALTY";
    const onClickRedirect = async () => {
        try {
            setLoadingRedirect(true);
            const trackedLink = await getcouponRedirect({
                link: coupon.linkUrl,
                source: utmSource,
                campaign: utmCampaign,
                userId: `${userId}`,
                coupon: `${coupon.id}`,
                store: coupon.store.slug,
                incentive: +incentiveId
            });

            const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

            if(isMobile()) {
                if (trackedLink) {
                    window.location.assign(trackedLink);
                } else {
                    showAlert("Link de redirecionamento não retornado.", "error");
                }
            } else {
                if (trackedLink) {
                    window.open(trackedLink, "_blank", "noopener,noreferrer");
                } else {
                    showAlert("Link de redirecionamento não retornado.", "error");
                }
            }

            
        } catch (error) {
            showAlert(`Erro ao redirecionar cupom: ${error.message}`, "error");
        } finally {
            setLoadingRedirect(false);
        }
    };

    const renderAuthenticatedButton = () => {
        if (type === "ONLINE") {
            return (
                <S.BotaoCupomBloco className="botao-cupom"  onClick={() => openModal(coupon)} style={{ cursor: "pointer" }}>
                    <S.BotaoCupomTopo buttonColor={buttonColor} buttonColorOnHover={"#" + categorie.buttonColorOnHover}>Pegar cupom</S.BotaoCupomTopo>
                    <S.BotaoCupomFundo
                        buttonColor={buttonColor}
                    >
                        {coupon.code}
                    </S.BotaoCupomFundo>
                </S.BotaoCupomBloco>
            );
        }

        return (
            <S.BotaoCupomBloco id="pegadoroferta" className="botao-oferta click-redirect">
                <S.BotaoOferta
                    buttonColor={buttonColor}
                    buttonColorOnHover={"#" + categorie.buttonColorOnHover}
                    onClick={onClickRedirect}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    {loadingRedirect ? (
                        <CircularProgress size={20} color="inherit" />
                    ) : (
                        "Ver Oferta"
                    )}
                </S.BotaoOferta>
            </S.BotaoCupomBloco>
        );
    };

    const renderUnauthenticatedButton = () => {
        if (type === "ONLINE") {
            return (
                <S.BotaoCupomBloco>
                <S.BotaoCupomTopo buttonColor={buttonColor} buttonColorOnHover={"#" + categorie.buttonColorOnHover}>
                    {isBlocked ? (
                        <Login
                        backgroundColor={`#${categorie.buttonColorOnHover}`}
                        name={
                            <div style={{ width: '100%', height: '100%' }}>
                                <S.LockBadgeWrapper buttonColorOnHover={categorie.buttonColorOnHover}>
                                <S.LockBadge 
                                leftOffset="60%" 
                                isCouponButton
                                className="lock-badge" buttonColor={categorie.buttonColor} buttonColorHover={categorie.buttonColorOnHover}>
                                    <LockIcon sx={{ color: "white", fontSize: "1.2rem" }}/>
                                </S.LockBadge>
                                <span style={{ color: "white" }}>Pegar cupom</span>
                                </S.LockBadgeWrapper>
                            </div>
                        }
                        hotAreaName={categorie.name}
                        longDescription={categorie.longDescription}
                        logo={`${LOGO_HOTAREA}${categorie.imageName}`}
                        border="none"
                        incentiveId={categorie.incentive_id}
                        slug={slug}
                        />
                    ): (
                        <div onClick={() => openModal(coupon)} style={{ cursor: "pointer", color: "white" }}>
                            Pegar cupom
                        </div>
                    )}
                </S.BotaoCupomTopo>
                <S.BotaoCupomFundo buttonColor={buttonColor} >
                    {coupon.code}
                </S.BotaoCupomFundo>
                </S.BotaoCupomBloco>
            );
        }
            return (
            <S.BotaoCupomBloco>
                <S.BotaoOferta buttonColor={buttonColor}  buttonColorOnHover={"#" + categorie.buttonColorOnHover}  onClick={!isBlocked ? onClickRedirect : undefined}>
                {isBlocked ? (
                    <Login
                    backgroundColor={`#${categorie.buttonColorOnHover}`}
                        name={
                        <S.LockBadgeWrapper buttonColorOnHover={categorie.buttonColorOnHover}>
                            <S.LockBadge className="lock-badge" buttonColor={categorie.buttonColor}>
                            <LockIcon sx={{ color: "white", fontSize: "1.2rem" }} />
                            </S.LockBadge>
                            <span style={{ color: "white" }}>Ver Oferta</span>
                        </S.LockBadgeWrapper>
                        }
                        width="100%"
                        hotAreaName={categorie.name}
                        longDescription={categorie.longDescription}
                        logo={`${LOGO_HOTAREA}${categorie.imageName}`}
                        border="none"
                        incentiveId={categorie.incentive_id}
                        slug={slug}
                    />
                ): loadingRedirect ? (
                    <CircularProgress size={20} color="inherit" />
                ) : (
                    "Ver Oferta"
                )}
                </S.BotaoOferta>
            </S.BotaoCupomBloco>
            );
    };

    return <>{isAuthenticated ? renderAuthenticatedButton() : renderUnauthenticatedButton()}</>;
};

export default OnlineOffer;